<div class="page-flex">
    <!-- Header -->
    <div class="channels-header-container">
        <div class="container-width channels-header">
            <div data-cy="all-channels-page-title" class="title-large">
                {{ "ops.channels.title" | translate }}
            </div>
            <app-filterbar
                [filterOption]="filterOption"
                [filterbarLabels]="filterLabels"
                [showSimpleFilter]="showSimpleFilter"
                [simpleFilterLabel]="simpleFilterLabel"
                (onFilterChange)="onFilterChange($event)"
                (resetFilter)="resetFilter()"
            ></app-filterbar>
        </div>
    </div>

    <!-- Channel List -->
    <div class="subgroup-list-container container-width">
        <div
            *ngFor="let group of showGroups.concat(showCustomGroups)"
            class="subgroup-entry"
            [routerLink]="['/ops', 'groups', group.id, 'channels']"
        >
            <div class="subgroup-entry-container">
                <div class="subgroup-title">
                    <div data-cy="all-channels-page-channel-group" class="name">
                        {{ group.displayName }}
                    </div>
                </div>

                <div class="alarms">
                    <div class="alarms-critical">
                        <mat-icon svgIcon="alarm" class="icon-alarm"></mat-icon>
                        <span
                            data-cy="all-channels-page-channel-group-critical-counter"
                            class="text"
                            >{{ group.alarms }}</span
                        >
                    </div>
                    <div class="alarms-caution">
                        <mat-icon svgIcon="alarm" class="icon-alarm"></mat-icon>
                        <span
                            data-cy="all-channels-page-channel-group-repose-counter"
                            >{{ group.cautions }}</span
                        >
                    </div>
                    <div class="alarms-warning">
                        <mat-icon svgIcon="alarm" class="icon-alarm"></mat-icon>
                        <span
                            data-cy="all-channels-page-channel-group-alarm-counter"
                            class="text"
                            >{{ group.warnings }}</span
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
